import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    lineHeight: 1.5,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    textDecoration: 'underline',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 10,
  },
  paragraph: {
    marginBottom: 10,
  },
  listItem: {
    marginLeft: 20,
    marginBottom: 5,
  },
  signatureSection: {
    marginTop: 40,
    paddingTop: 20,
    borderTop: '1px solid #000',
  },
  signatureLabel: {
    marginTop: 5,
  },
});

const NDAPDF = ({ partyAName, partyAAddress }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View>
        <Text style={styles.title}>NON-DISCLOSURE AGREEMENT (NDA)</Text>

        <Text style={styles.paragraph}>
          This Non-Disclosure Agreement (“Agreement”) is made and entered into on this{' '}
          <Text style={{ fontWeight: 'bold' }}>{new Date().toLocaleDateString()}</Text>, by and between:
        </Text>

        <Text style={styles.paragraph}>
          <Text style={{ fontWeight: 'bold' }}>Party A:</Text>{' '}
          {partyAName || '________________________'}, a company registered under the laws of India,
          having its registered office at {partyAAddress || '________________________'}
          (hereinafter referred to as “Party A”).
        </Text>

        <Text style={{ textAlign: 'center', marginVertical: 10 }}>AND</Text>

        <Text style={styles.paragraph}>
          <Text style={{ fontWeight: 'bold' }}>Party B:</Text> SPH AVIATION PRIVATE LIMITED, CIN:
          U62100HR2022PTC105328, a company incorporated under the Companies Act, 1956, having its registered office
          at Plot 251 Udyog Vihar, Phase IV, Sector 18, Gurugram, Haryana, 122015 (hereinafter referred to as
          “SPH Aviation” or “Party B”).
        </Text>

        <Text style={styles.paragraph}>
          Party A and Party B are hereinafter collectively referred to as the “Parties” and individually as a “Party”.
        </Text>

        {/* 1 */}
        <Text style={styles.sectionTitle}>1. Purpose</Text>
        <Text style={styles.paragraph}>
          The Parties intend to explore potential business opportunities and collaborations (“Proposed Relationship”)
          and in connection therewith may exchange certain confidential information. This Agreement sets forth the terms
          and conditions under which such information will be kept confidential.
        </Text>

        {/* 2 */}
        <Text style={styles.sectionTitle}>2. Definition of Confidential Information</Text>
        <Text style={styles.paragraph}>For the purposes of this Agreement, “Confidential Information” includes:</Text>
        <Text style={styles.listItem}>(a) Business strategies, plans, and operations;</Text>
        <Text style={styles.listItem}>(b) Technical data, designs, specifications, know-how, software, and intellectual property;</Text>
        <Text style={styles.listItem}>(c) Customer, supplier, and partner details;</Text>
        <Text style={styles.listItem}>(d) Financial information, pricing, contracts, and agreements;</Text>
        <Text style={styles.listItem}>(e) Any information designated as confidential by the Disclosing Party.</Text>

        {/* 3 */}
        <Text style={styles.sectionTitle}>3. Exclusions from Confidential Information</Text>
        <Text style={styles.listItem}>(a) Information that is or becomes publicly available without breach of this Agreement;</Text>
        <Text style={styles.listItem}>(b) Information lawfully received from a third party without restriction;</Text>
        <Text style={styles.listItem}>(c) Information already in the Receiving Party’s possession before disclosure;</Text>
        <Text style={styles.listItem}>(d) Information independently developed without reference to the Disclosing Party’s information;</Text>
        <Text style={styles.listItem}>(e) Information required to be disclosed by law or governmental order, provided prompt notice is given to the Disclosing Party.</Text>

        {/* 4 */}
        <Text style={styles.sectionTitle}>4. Obligations of the Receiving Party</Text>
        <Text style={styles.listItem}>(a) Non-Disclosure: The Receiving Party shall not disclose Confidential Information to any third party without prior written consent of the Disclosing Party.</Text>
        <Text style={styles.listItem}>(b) Non-Use: The Receiving Party shall not use Confidential Information for any purpose other than evaluating the Proposed Relationship.</Text>
        <Text style={styles.listItem}>(c) Protection: The Receiving Party shall use at least the same degree of care to protect the Confidential Information as it uses for its own information of like importance.</Text>
        <Text style={styles.listItem}>(d) Return/Destruction: Upon written request, the Receiving Party shall return or destroy all Confidential Information.</Text>

        {/* 5 */}
        <Text style={styles.sectionTitle}>5. Permitted Disclosures</Text>
        <Text style={styles.paragraph}>
          The Receiving Party may disclose Confidential Information to its employees, consultants, contractors, or
          advisors on a need-to-know basis, provided they are bound by confidentiality obligations at least as strict as
          those contained herein.
        </Text>

        {/* 6 */}
        <Text style={styles.sectionTitle}>6. Duration of Confidentiality Obligations</Text>
        <Text style={styles.listItem}>(a) Confidentiality obligations remain for 3 years after termination of this Agreement.</Text>
        <Text style={styles.listItem}>(b) Trade secrets shall be protected as long as they remain trade secrets under applicable law.</Text>

        {/* 7 */}
        <Text style={styles.sectionTitle}>7. Intellectual Property</Text>
        <Text style={styles.listItem}>(a) Each Party retains ownership of its pre-existing intellectual property and Confidential Information.</Text>
        <Text style={styles.listItem}>(b) No license or other rights are granted under this Agreement except the limited right to use Confidential Information for the Proposed Relationship.</Text>
        <Text style={styles.listItem}>(c) Any joint intellectual property developed shall be subject to a separate written agreement between the Parties.</Text>

        {/* 8 */}
        <Text style={styles.sectionTitle}>8. No Obligation to Proceed</Text>
        <Text style={styles.paragraph}>
          Nothing in this Agreement obligates either Party to enter into any definitive agreement or proceed with any
          transaction or business relationship.
        </Text>

        {/* 9 */}
        <Text style={styles.sectionTitle}>9. Remedies</Text>
        <Text style={styles.paragraph}>
          The Receiving Party acknowledges that any unauthorized disclosure or use of Confidential Information may cause
          irreparable harm to the Disclosing Party, and that monetary damages may be inadequate. Accordingly, the
          Disclosing Party shall be entitled to seek injunctive relief and any other remedies available at law or in
          equity.
        </Text>

        {/* 10 */}
        <Text style={styles.sectionTitle}>10. Governing Law & Jurisdiction</Text>
        <Text style={styles.paragraph}>
          This Agreement shall be governed by and construed in accordance with the laws of India. The courts of New
          Delhi shall have exclusive jurisdiction over any disputes arising under this Agreement.
        </Text>

        {/* 11 */}
        <Text style={styles.sectionTitle}>11. Dispute Resolution</Text>
        <Text style={styles.paragraph}>
          The Parties shall first attempt to resolve any dispute through good-faith negotiations. If such negotiations
          fail, the dispute shall be referred to arbitration in New Delhi in accordance with the Arbitration and
          Conciliation Act, 1996. The arbitral award shall be final and binding.
        </Text>

        {/* 12 */}
        <Text style={styles.sectionTitle}>12. Term and Termination</Text>
        <Text style={styles.listItem}>(a) This Agreement remains in effect until terminated by either Party upon 30 days’ prior written notice.</Text>
        <Text style={styles.listItem}>(b) Termination shall not affect the obligations of confidentiality with respect to Confidential Information disclosed prior to termination.</Text>

        {/* 13 */}
        <Text style={styles.sectionTitle}>13. Miscellaneous</Text>
        <Text style={styles.listItem}>(a) Entire Agreement: This Agreement constitutes the entire agreement between the Parties regarding its subject matter and supersedes all prior discussions.</Text>
        <Text style={styles.listItem}>(b) Amendments: Any amendment must be in writing and signed by both Parties.</Text>
        <Text style={styles.listItem}>(c) No Waiver: Failure to enforce any provision shall not constitute a waiver.</Text>
        <Text style={styles.listItem}>(d) Counterparts: This Agreement may be executed in counterparts, each of which shall be deemed an original.</Text>

        {/* 14 */}
        <Text style={styles.sectionTitle}>14. Execution</Text>
        <Text style={styles.paragraph}>
          IN WITNESS WHEREOF, the Parties hereto have executed this Non-Disclosure Agreement on the date first written
          above.
        </Text>

        <View>
          <Text style={{ fontWeight: 'bold' }}>For Party A</Text>
          <Text style={styles.signatureLabel}>Company: __________________________</Text>
          <Text style={styles.signatureLabel}>Name: _____________________________</Text>
          <Text style={styles.signatureLabel}>Designation: ______________________</Text>
          <Text style={styles.signatureLabel}>Date: {new Date().toLocaleDateString()}</Text>
        </View>

        <View style={styles.signatureSection}>
          <Text style={{ fontWeight: 'bold' }}>For SPH AVIATION PRIVATE LIMITED</Text>
          <Text style={styles.signatureLabel}>Name: _____________________________</Text>
          <Text style={styles.signatureLabel}>Designation: ______________________</Text>
          <Text style={styles.signatureLabel}>Date: {new Date().toLocaleDateString()}</Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default NDAPDF;
